export default "__VITE_ASSET__BAo5u3r$__"